import React from 'react';
import { useEffect, useState } from 'react';
type GetTextProps = {
  text: string;
  textLength: number;
  isMobileDevice: boolean;
  url?: string;
};

const TruncateText = ({
  text,
  isMobileDevice,
  textLength,
  url = ''
}: GetTextProps) => {
  const [readMore, setReadMore] = useState(true);
  useEffect(() => {
    if (text.length > textLength) setReadMore(false);
  }, []);
  const toggleReadMode = () => {
    setReadMore(!readMore);
  };
  return (
    <>
      {text.length > textLength && isMobileDevice ? (
        <>
          {readMore && <span>{text}</span>}
          {!readMore && <span>{text.substring(0, textLength)}...</span>}
          <span> </span>
          <span>
            <span
              style={{ whiteSpace: 'nowrap' }}
              className={`deepskyBlueText`}
              onClick={toggleReadMode}
            >
              {readMore ? 'Read Less' : 'Read More'}
            </span>
          </span>
        </>
      ) : (
        <>{text}</>
      )}
    </>
  );
};
export default TruncateText;
